import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import React, { useState, useEffect } from "react";

import { MdDehaze } from "react-icons/md";
import images from "../../../Resources/images/images.jpg";
import { Link, useNavigate } from "react-router-dom";
import Collapse from "@kunukn/react-collapse";
import Cookies from "js-cookie";

function Toolbar({ setShowSidebar, showSidebar, hideSideBar, setHideSideBar }) {
  const [toggleArrowDown, setToggleArrowDown] = useState(false);
  const [userName, setUserName] = useState("");
  const [role, setRole] = useState("");
  const navigate = useNavigate();
  const Logout = () => {
    Cookies.remove("token");
    navigate("/Login");
  };
  useEffect(() => {
    if (Cookies) {
      let username = Cookies.get("username");
      let role = Cookies.get("role");
      let data = username.split("@");
      console.log(data);
      setUserName(data[0]);
      setRole(role);
    }
  }, [Cookies]);
  return (
    <div
      className="bg-gray-700  z-40 relative laptop:z-50 w-full  mobileL:w-full  text-white flex 
     justify-between items-center px-2 tablet:px-8 py-4  "
    >
      <div onClick={() => setShowSidebar(!showSidebar)}>
        {role === "admin" ? (
          <MdDehaze className="w-8 h-10  cursor-pointer" />
        ) : (
          ""
        )}
      </div>

      <div className="flex gap-10 items-center ">
        {/* <Link to="/billing"> */}{" "}
        {role === "admin" ? (
          <div className="flex gap-3">
            <div>
              <button
                className="bg-gray-400 font-semibold px-6 py-2  text-sm
      rounded-md capitalize transition-all ease-in-out duration-300 
       hover:scale-105 text-white hover:bg-blue-500"
                onClick={() => {
                  setHideSideBar(true);
                  navigate("/attendence", { state: { hideSideBar } });
                }}
              >
                Attendence
              </button>
            </div>
            <div>
              <button
                className="bg-gray-400 font-semibold px-6 py-2  text-sm
      rounded-md capitalize transition-all ease-in-out duration-300 
       hover:scale-105 text-white hover:bg-SecondaryColor"
                onClick={() => {
                  setHideSideBar(true);
                  navigate("/billing", { state: { hideSideBar } });
                }}
              >
                billing
              </button>
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="flex gap-2 items-center">
          <div className="rounded-full ">
            {!images ? (
              <img
                src={images}
                alt="loading..."
                height="35"
                width="35"
                className="rounded-full"
              />
            ) : (
              <div className="rounded-full capitalize h-10 w-10 text-black flex justify-center items-center bg-gray-200">
                {userName[0]}
              </div>
            )}
          </div>
          <button
            // tabIndex={0}
            onBlur={() => setToggleArrowDown(false)}
            className="flex gap-2 cursor-pointer items-center"
            onClick={() => setToggleArrowDown(!toggleArrowDown)}
          >
            <div className="">
              <div className="capitalize text-xs tablet:text-sm">
                {" "}
                {userName}
              </div>
              <div className="capitalize text-xs tablet:text-sm"> {role}</div>
            </div>
            <div>
              {!toggleArrowDown ? (
                <IoMdArrowDropdown className="w-8 h-8" />
              ) : (
                <IoMdArrowDropup className="w-8 h-8" />
              )}
            </div>
          </button>
          {/* <div className="w-full h-[1px] bg-gray-300 mb-5 hidden laptop:hidden laptop:mb-0"></div> */}

          {/* {toggleArrowDown ?  */}
          <div className="absolute   z-[1000] top-12 right-8">
            <Collapse
              isOpen={toggleArrowDown}
              // state ko value yeha change huni raicha like true or false
              className={`a`}
              transition="height 800ms cubic-bezier(0.4, 0, 0.2, 1)"
              aria-hidden={toggleArrowDown ? "false" : "true"}
              elementType="article"
              render={() => (
                <React.Fragment>
                  {" "}
                  <div
                    className="tipCard px-2   rounded-md py-4 
                   "
                  >
                    <div
                      onClick={() => Logout()}
                      className="bg-blue-500 hover:bg-blue-500 px-7  cursor-pointer
            rounded-md text-white font-semibold relative  z-50 capitalize hover:text-white py-1"
                    >
                      logout
                    </div>
                  </div>
                </React.Fragment>
              )}
            />
          </div>

          {/* <div className="w-full h-[1px] bg-gray-300 mb-5 laptop:hidden laptop:mb-0"></div> */}
        </div>
      </div>
    </div>
  );
}

export default Toolbar;
